module.exports = __webpack_public_path__ + "img/00011.3359153d.webp";